module.exports = __webpack_public_path__ + "static/media/dhis2-logo.1054ccda.png";